import React, { Component, Fragment } from "react";
import {
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBDataTable
} from "mdbreact";
import {
  getContactFromCompanyId,
  addContactToCompanyId,
  deleteContactApi,
  updateContactToCompanyId
} from "../../../../Api/api";

import {
  getAllHomePageApi,
  getAllHomePageByCompanyApi,
} from "../../../../Api/homePageApi";
import SpinnerPage from "../../../pages/SpinnerPage";

import { successToast, errorToast } from "../../../../utils/toast";

import HomeDataTable from "./home-data-table";
import { getAllBlogsByCompanyApi, deleteBlogApi } from "../../../../Api/blogApi";

// import CompanyContext from "../..//context/companyContext";

interface HomeInterfaceProps {
  id: string;
  project_title: string;
  project_description: string;
  image_url: string;
  video_url: string;
}

interface HomeInterfaceState {
  home: HomeInterface;
  blogs: [];
  modal: boolean;
  edit: boolean;

  optionActive: string;
  optionActiveId: string;
  loading: boolean;
}

interface HomeInterface {
  id: string;
  project_title: string;
  project_description: string;
  image_url: string;
  video_url: string;
}

export default class BlogTab extends Component<any, HomeInterfaceState> {
  // static contextType = CompanyContext;

  constructor(props: any) {
    super(props);
    this.state = {
      home: {
        id: "",
        project_title: "",
        project_description: "",
        image_url: "",
        video_url: ""
      },
      blogs: [],
      modal: false,
      edit: false,
      optionActive: "",
      optionActiveId: "",
      loading: false
    };
    this.clear = this.clear.bind(this);
    this.toogleActiveOption = this.toogleActiveOption.bind(this);
    this.deleteBlog = this.deleteBlog.bind(this);
  }

  componentDidMount() {
    this.setState({ loading: true });
    getAllBlogsByCompanyApi(this.props.companyId)
      .then((res: any) => {
        console.log("Success :: ", res);
        this.setState({ blogs: res, loading: false });
      })
      .catch((err: any) => {
        alert("Error to create a company" + err);
      });
  }

  deleteBlog = (rowdata: any) => {
    if (window.confirm("Are you sure you want to delete this blog?")) {
      deleteBlogApi(rowdata.id)
        .then((res: any) => {
          successToast("Blog Deleted Sucessfully");
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .catch((err: any) => {
          alert("Error to delete a company blog" + err);
        });
    }
  };

  toogleActiveOption = (id: string) => {
    this.setState({
      optionActive: this.state.optionActive == "" ? "active" : "",
      optionActiveId: id
    });
  };

  clear() {
    this.setState({
      home: {
        ...this.state.home,
        project_title: "",
        project_description: "",
        image_url: "",
        video_url: ""
      }
    });
  }

  render() {
    const data = {
      columns: [
        {
          title: "Date",
          field: "created_at"
        },
        {
          title: "Author",
          field: "author"
        },
        {
          title: "Blog Title",
          field: "title"
        },
        {
          title: "Blog Description",
          field: "description"
        }
      ]
    };

    const blogs = this.state.blogs;
    const companyId = this.props.companyId;

    return this.state.loading ? (
      <SpinnerPage />
    ) : (
      <div>
        <div className="contact-table">
          <HomeDataTable
            columns={data.columns}
            rows={blogs}
            companyId={companyId}
            deleteBlog={this.deleteBlog}
          />
        </div>
      </div>
    );
  }
}
